
    <mat-sidenav-container
      fxLayout="column"
      class="sidenav full-height full-width"
      (backdropClick)="onClose()"
    >
      <mat-sidenav
        [style.max-width]="(width$ | async) + '%'"
        class="full-width"
        #sidenav
        mode="over"
        position="end"
        autoFocus="false"
        [opened]="opened$ | async"
        (closed)="onClose()"
      >
        <div class="padding-16">
          <ng-template #sidenavContent></ng-template>
        </div>
      </mat-sidenav>

      <mat-sidenav-content fxLayout="column" class="full-height">
        <ng-content></ng-content>
      </mat-sidenav-content>
    </mat-sidenav-container>
  